// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './plugins/vuetify'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Notifications from 'vue-notification'
import VueMoment from 'vue-moment'
import VModal from 'vue-js-modal'
import CKEditor from 'ckeditor4-vue'
Vue.config.productionTip = false;
Vue.filter('priceFormat', function (value) {
  if (!value) return '0';
  let mValue = Number(value).toFixed(3);
  mValue = Number(mValue)
  mValue = mValue.toString().replace('.', ',');
  return mValue + '€'
});
Vue.use( CKEditor );
Vue.use(Vuetify);
Vue.use(Notifications);
Vue.use(VueMoment);
Vue.use(VModal);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js